import { Directive, ElementRef, Input, NgModule, OnDestroy, OnInit } from '@angular/core';
import { Subject, fromEvent } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { UserwayService } from './userway.service';

@Directive({
  selector: 'iframe[lp2UserwaySync]',
})
export class UserwaySyncDirective implements OnInit, OnDestroy {
  // bare attribute posts to the iframe src's origin; a bound origin that did not resolve posts nothing
  @Input() lp2UserwaySync: string;

  private destroyed$ = new Subject<void>();

  constructor(
    private el: ElementRef<HTMLIFrameElement>,
    private userwayService: UserwayService
  ) {}

  ngOnInit() {
    fromEvent(this.el.nativeElement, 'load')
      .pipe(
        switchMap(() => this.userwayService.settings$),
        takeUntil(this.destroyed$)
      )
      .subscribe((data) => this.post(data));
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  private post(data: {}): void {
    const targetOrigin = this.lp2UserwaySync === '' ? this.srcOrigin() : this.lp2UserwaySync;
    if (targetOrigin) {
      this.el.nativeElement.contentWindow.postMessage(data, targetOrigin);
    }
  }

  private srcOrigin(): string | null {
    const { origin } = new URL(this.el.nativeElement.src, document.baseURI);
    return origin === 'null' ? null : origin;
  }
}

@NgModule({
  declarations: [UserwaySyncDirective],
  exports: [UserwaySyncDirective],
})
export class UserwaySyncModule {}



// WEBPACK FOOTER //
// ./ts/app/shared/userway-sync.directive.ts